<script>
import gql from 'graphql-tag'

export default {
  data() {
    return {
      unreadDialogCount: 0,
    }
  },
  apollo: {
    unreadDialogCount: {
      query: gql`
        query me {
          me {
            globalId
            localId
            activeAccount {
              globalId
              unreadDialogsCountForViewer
            }
          }
        }
      `,
      update: (data) => data?.me?.activeAccount?.unreadDialogsCountForViewer,
    },
  },
  render() {
    return this.$slots.default({
      count: this.unreadDialogCount,
      loading: this.$apollo.loading,
    })
  },
}
</script>
